'use client'

import React from 'react'
import { Breadcrumbs } from '../_components/Breadcrumps'
import AnimatedSection from '@/components/AnimatedSection'
import Main from './_blocks/Main'
import ReadySolutions from './_blocks/ReadySolutions'
import ItProduct from './_blocks/ItProduct'
import Industries from './_blocks/Industries'
import CtaBanner from './_blocks/CtaBanner'
import Clients from '@/app/services/_blocks/Clients'
import Instrument from '@/app/services/_blocks/Instrument'
import Contact from '../_blocks/Main_redesign/Contact'
import styles from './styles.module.css'

export default function ITSolutionsPage() {
	return (
		<>
			<Breadcrumbs className={styles.breadcrumbs} />
			<main className={styles.main}>
				<Main />
				<ReadySolutions />
				<AnimatedSection animation="slideUp">
					<div className={styles.itProductBlock}>
						<ItProduct />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.industriesBlock}>
						<Industries />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.ctaBannerBlock}>
						<CtaBanner />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.clientsBlock}>
						<Clients />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.instrumentBlock}>
						<Instrument />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.contactBlock}>
						<Contact />
					</div>
				</AnimatedSection>
			</main>
		</>
	)
}
